
riot.tag2('brands-list-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Бренды</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Brand" cols="{parent.cols}" search="true" dblclick="{parent.opts.submit.bind(this)}" reload="true">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];
});


// WEBPACK FOOTER //
// ./pages/products/brands/brands-list-select-modal.tag